import React from 'react';

const DragHandleIcon = ({ width = 4, height = 16, color = 'currentColor' }) => (
  <svg viewBox="0 0 4 16" width={width} height={height} fill="none">
    <circle cx="2" cy="2.5" r="1.5" fill={color} />
    <circle cx="2" cy="8"   r="1.5" fill={color} />
    <circle cx="2" cy="13.5" r="1.5" fill={color} />
  </svg>
);

export default DragHandleIcon;
